export function isReasonablyValidEmail(value: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

export function formatApprovalDateDisplay(value: string | Date | null | undefined) {
  if (!value) return new Date().toLocaleString("en-SG", { dateStyle: "long", timeStyle: "short" });
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return new Date().toLocaleString("en-SG", { dateStyle: "long", timeStyle: "short" });
  return d.toLocaleString("en-SG", { dateStyle: "long", timeStyle: "short" });
}

export function buildSalespersonContactHref(input: {
  proposalRef: string;
  email?: string | null;
  contact?: string | null;
}): string | null {
  const phoneRaw = String(input.contact ?? "").trim().replace(/[^\d+]/g, "");
  const waDigits = phoneRaw.replace(/^\+/, "").replace(/^0+/, "");
  if (waDigits.length > 0) {
    const message = `Hi, I have a question about proposal ${input.proposalRef}.`;
    return `https://wa.me/${waDigits}?text=${encodeURIComponent(message)}`;
  }
  const email = String(input.email ?? "").trim();
  if (email) {
    const subject = `Question about proposal ${input.proposalRef}`;
    return `mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent(subject)}`;
  }
  return null;
}

/** WhatsApp deep link for archived / no-longer-valid customer proposal page. */
export function buildArchivedProposalWhatsAppHref(input: {
  salespersonName?: string | null;
  proposalRef: string;
  contact?: string | null;
}): string | null {
  const phoneRaw = String(input.contact ?? "").trim().replace(/[^\d+]/g, "");
  const waDigits = phoneRaw.replace(/^\+/, "").replace(/^0+/, "");
  if (waDigits.length === 0) return null;
  const name = String(input.salespersonName ?? "").trim() || "there";
  const ref = String(input.proposalRef ?? "").trim() || "—";
  const message = `Hi ${name},\n\nI would like to revisit my previous proposal.\n\nProposal Reference:\n${ref}`;
  return `https://wa.me/${waDigits}?text=${encodeURIComponent(message)}`;
}
